import React from 'react'
import useFormV2 from '../../form-v2/form.hook'
import FormV2 from '../../form-v2/form.component'
import { isObject } from '../../form-v2/utils'

const LabPortalenUserFormComponent = ({
    groupId,
    _type,
    lang,
    userId,
    onAfterSubmit,
}) => {
    const form = useFormV2({
        autoComplete: false,
        autoFetch: {
            url: `/integrations/clinic/labportalen/user/${groupId}?userId=${userId}`,
            method: 'get',
        },
        autoSubmit: {
            url: `/integrations/clinic/labportalen/user/${groupId}`,
            method: 'post',
            onBeforeSubmit: (data) => {
                // if (data.user.CanMakeRequisitionsLevel === true) data.user.CanMakeRequisitionsLevel = 1;
                // else data.user.CanMakeRequisitionsLevel = 0;

                if (data.user.CanMakeResultsProtected === true) data.user.CanMakeResultsProtected = 1;
                else data.user.CanMakeResultsProtected = 0;

                if (data.user.CanSignResults === true) data.user.CanSignResults = 1;
                else data.user.CanSignResults = 0;

                if (typeof data.user.Userrole === 'string') data.user.Userrole = Number(data.user.Userrole);
                if (typeof data.user.CanMakeRequisitionsLevel === 'string') data.user.CanMakeRequisitionsLevel = Number(data.user.CanMakeRequisitionsLevel);

                if ([1, 3].includes(data.user.CanMakeRequisitionsLevel)) data.user.CanMakeRequisitions = true;
                else data.user.CanMakeRequisitions = false;

                if ([2, 3].includes(data.user.CanMakeRequisitionsLevel)) data.user.MakesRequisitionsForOthers = true;
                else data.user.MakesRequisitionsForOthers = false;

                return data;
            },
            onAfterSubmit: onAfterSubmit
        },
        onBeforePopulate: (data) => {
            // if (data.user.CanMakeRequisitionsLevel === 1) data.user.CanMakeRequisitionsLevel = true;
            // else data.user.CanMakeRequisitionsLevel = false;

            if (data.user.CanMakeResultsProtected === 1) data.user.CanMakeResultsProtected = true;
            else data.user.CanMakeResultsProtected = false;

            if (data.user.CanSignResults === 1) data.user.CanSignResults = true;
            else data.user.CanSignResults = false;

            if (typeof data.user.Userrole === 'number') data.user.Userrole = String(data.user.Userrole);
            if (typeof data.user.CanMakeRequisitionsLevel === 'number') data.user.CanMakeRequisitionsLevel = String(data.user.CanMakeRequisitionsLevel);

            if (data?._type === 'create' && isObject(data.user)) {
                data.user.CanSignResults = true;
                data.user.CanMakeResultsProtected = true;
            }

            if (data?.user?.Cellphone) data.user.Cellphone = data.user.Cellphone.replace(/\D/g, '').slice(0, 15);
            if (data?.user?.Phone) data.user.Phone = data.user.Phone.replace(/\D/g, '').slice(0, 15);

            return data;
        },
        title: _type === 'create' ? 'Create user' : 'Edit user',
        sections: {
            'main': {
                title: 'User Data',
            },
            'perm': {
                title: 'Roles and Permissions',
            }
        }
    }, {
        _type: {
            type: 'hidden',
            initialValue: _type,
        },

        // User
        'user._id': {
            type: 'hidden',
            initialValue: userId,
        },
        'user.Usertype': {
            type: 'hidden',
            initialValue: 0,
        },
        'user.EditOrderCodes': {
            type: 'hidden',
            initialValue: null,
        },
        'user.Departmentid': {
            type: 'hidden',
            initialValue: 0,
        },
        'user.Name': {
            type: 'text',
            label: 'Name',
            isRequired: true,
            cols: { lg: 6 },
            section: 'main',
            info: 'Please enter the full name of the user.'
        },
        'user.Usercode': {
            type: 'text',
            label: 'Username',
            isRequired: true,
            cols: { lg: 6 },
            instantTransformer: (value) => value?.toLowerCase().replace(/\s/g, ''),
            submitTransformer: (value) => value?.toLowerCase().replace(/\s/g, ''),
            info: 'LabPortalen might prefix the username with organisation id!',
            section: 'main',
            isDisabled: (_, e) => e?._type === 'edit',
        },
        'user.Email': {
            type: 'email',
            label: 'Email',
            isRequired: true,
            cols: { lg: 6 },
            section: 'main',
            info: 'It is mandatory to enter e-mail.'
        },
        'user.Password': {
            type: 'hidden',
            label: 'Password',
            initialValue: '',
            cols: { lg: 6 },
            section: 'main',
        },
        'user.Phone': {
            type: 'text',
            label: 'Phone',
            isRequired: true,
            cols: { lg: 6 },
            section: 'main',
            instantTransformer: (value) => value?.replace(/\D/g, '').slice(0, 15),
            submitTransformer: (value) => value?.replace(/\D/g, '').slice(0, 15),
            validator: (value) => value === '' || (value?.length <= 15 && /^\d+$/.test(value)) ? null : 'Please enter a valid phone number!',
            info: 'The number is entered with numbers only and without spaces. For example, 46712345678 or 0712345678.'
        },
        'user.Cellphone': {
            type: 'text',
            label: 'Cellphone',
            cols: { lg: 6 },
            section: 'main',
            instantTransformer: (value) => value?.replace(/\D/g, '').slice(0, 15),
            submitTransformer: (value) => value?.replace(/\D/g, '').slice(0, 15),
            validator: (value) => value === '' || (value?.length <= 15 && /^\d+$/.test(value)) ? null : 'Please enter a valid phone number!',
            info: 'The number is entered with numbers only and without spaces. For example, 46712345678 or 0712345678.'
        },
        'user.Hsaid': {
            type: 'text',
            label: 'HSA ID',
            cols: { lg: 6 },
            section: 'main',
            info: 'HSA-ID must be specified if the user is to log in with SITHS card. Enter complete HAS-ID (all characters). For example: SE165567766992-10PB.'
        },
        'user.Userrole': {
            type: 'select',
            initialValue: '1',
            isRequired: true,
            label: 'Role',
            config: {
                options: [{
                    value: '0',
                    label: 'Inaktiv'
                }, {
                    value: '1',
                    label: 'Användare'
                }, {
                    value: '2',
                    label: 'Administratör'
                },
                // {
                //     value: '3',
                //     label: 'Avtalsansvarig'
                // }, 
                {
                    value: '100',
                    label: 'Provtagare'
                }]
            },
            cols: { lg: 6 },
            section: 'perm',
            description: (s) => {
                const role = s?.['user.Userrole']?.value;
                if (role === '0') return 'Has no longer access to LabPortalen but can be activated by Administrator.';
                if (role === '1') return 'Has access to Incoming/Outgoing/Patient overview.';
                if (role === '2') return 'Has access to Incoming/Outgoing/Patient overview and Medical administration and administration of users below Account administration.';
                if (role === '100') return 'Has access to Patient overview.';

                return 'Please select a role.';
            }
        },
        'user.CanMakeRequisitionsLevel': {
            type: 'select',
            label: 'Competence Level',
            cols: { lg: 6 },
            section: 'perm',
            isRequired: true,
            placeholder: 'Please select',
            config: {
                options: [
                    {
                        value: '0',
                        label: 'May not create eRemiss'
                    },
                    {
                        value: '1',
                        label: 'May create eRemiss in their own name'
                    },
                    {
                        value: '2',
                        label: 'May only create eRemiss for others'
                    },
                    {
                        value: '3',
                        label: 'May create eRemiss in their own name and for others'
                    }
                ]
            },
            description: (s) => {
                const level = s?.['user.CanMakeRequisitionsLevel']?.value;
                if (level === '0') return 'Does not have the right to create e-referrals in LabPortalen.';
                if (level === '1') return 'Has the right to create e-referrals in LabPortalen for themselves.';
                if (level === '2') return 'Has the right to create e-referrals in LabPortalen only for other users.';
                if (level === '3') return 'Has the right to create e-referrals both for themselves and other users.';

                return 'Please select a competence level.';
            },

        },
        // 'user.CanMakeRequisitions': {
        //     type: 'switch',
        //     label: 'Can make requisitions',
        //     cols: { lg: 6, xl: 4 },
        //     section: 'perm',
        // },
        'user.CanMakeResultsProtected': {
            type: 'checkbox',
            label: 'Can make results protected',
            section: 'perm',
            initialValue: true,
            info: "This setting should be set to the users who should have the ability to block journal entries in LabPortalen at the patient's request."
        },
        'user.CanSignResults': {
            type: 'checkbox',
            label: 'Can sign results',
            section: 'perm',
            initialValue: true,
            // onChangeCallback: (value) => {
            //     if (value === false) {
            //         form?.set?.('user.CanSignDepartmentresults', false);
            //         form?.set?.('user.CanSignOrganisationresults', false);
            //     }
            // },
            info: "This setting should be set on the users who have signing responsibilities in LabPortalen. A user who should register local results needs to have this setting activated."
        },
        // 'user.CanSignDepartmentresults': {
        //     type: 'checkbox',
        //     label: 'Can sign department results',
        //     section: 'perm',
        //     isDisabled: (s) => s?.['user.CanSignResults']?.value !== true,
        // },
        // 'user.CanSignOrganisationresults': {
        //     type: 'checkbox',
        //     label: 'Can sign organisation results',
        //     section: 'perm',
        //     isDisabled: (s) => s?.['user.CanSignResults']?.value !== true,
        // },
        // 'user.MakesRequisitionsForOthers': {
        //     type: 'switch',
        //     label: 'Makes requisitions for others',
        //     cols: { lg: 6, xl: 4 },
        //     section: 'perm',
        // },
    }, {
        _type
    })
    return (
        <FormV2
            data={form}
            lang={lang}
        />
    )
}

export default LabPortalenUserFormComponent